import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../../../Constants/ClientRoutingConstants";
import { warningTriangleIcon } from "@progress/kendo-svg-icons";

export default function SessionExpiredPage(): ReactElement {
  const localizationService = useLocalization();
  let navigate = useNavigate(); 
  const [visible, setVisible] = React.useState<boolean>(true);

  return (
    <Dialog>
      <div className="my-8">
        <div className="text-center mb-5">
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '72px',
            height: '72px'
          }}>
            <SvgIcon icon={warningTriangleIcon} size="xxlarge" />
          </span>
        </div>
        <div style={{ textAlign: "center" }}>
          {`${localizationService.toLanguageString('custom.sessionExpired', enMessages.custom.sessionExpired)}`}
        </div>
      </div>
      <DialogActionsBar layout="center">
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          style={{padding:'8px 20px'}}
          onClick={() => {
            navigate(ClientRoutes.Logout)
            setVisible(!visible)
          }}
        >
          OK
        </button>
      </DialogActionsBar>
    </Dialog>
  );
}
